import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { MASCOT } from "@/lib/api";

function LoadingScreen() {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center mesh-warm">
      <img src={MASCOT.tilt} alt="Solange" className="animate-float-slow w-24 h-24 rounded-full object-cover" />
      <p className="mt-4 text-[#8c735f] text-sm">Carregando...</p>
    </div>
  );
}

export function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading || user === null) return <LoadingScreen />;
  if (!user) return <Navigate to="/login" replace />;
  if (user.role === "admin") return <Navigate to="/admin" replace />;
  if (user.subscription_status !== "active") return <Navigate to="/assinatura-inativa" replace />;
  return children;
}

export function AdminRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading || user === null) return <LoadingScreen />;
  if (!user) return <Navigate to="/login" replace />;
  if (user.role !== "admin") return <Navigate to="/painel" replace />;
  return children;
}
